<div class="my-3 confirm-dialog-container">
  <div class="w-100 text-center">
    <span class="close-button" (click)="close()">
      <i class="pi pi-times"></i>
    </span>
    <i *ngIf="!config.data.attention" class="pi pi-question-circle dialog-icon"></i>
    <i *ngIf="config.data.attention" class="pi pi-exclamation-triangle icon dialog-icon"></i>
  </div>

  <div class="w-100 text-center dialog-label my-3">{{ config.data.header }}</div>

  <div class="dialog-buttons">
    <button *ngIf="!config.data.confirm" pButton class="p-button-rounded button-confirm" [style]="{'width':'221px'}"
      (click)="okay()">{{('confirmButton' | translate).toUpperCase()}}</button>
    <button *ngIf="config.data.confirm" pButton class="p-button-rounded button-confirm" (click)="okay()">{{('yes' |
      translate).toUpperCase()}}</button>
    <button *ngIf="config.data.confirm" pButton class="p-button-rounded p-button-secondary button-confirm"
      (click)="close()">{{('no' | translate).toUpperCase()}}</button>
  </div>
</div>